import { defineComponent, h, computed, onUnmounted, provide } from 'vue';
import { Modal } from '@/ui/components/Modal';
import { pageSubtitle } from '@/ui/components';
import { t } from '@/ui/i18n/i18n';
import { activeIssueEditable } from '@/ui/pages/conduct/ConductInspectionStore';
import { PrefilledFields } from '@/ui/pages/conduct/FillDetailsIssueModal/PrefilledFields';
import { FillFields } from '@/ui/pages/conduct/FillDetailsIssueModal/FillFields';
import { Button } from '@/ui/components/Button';
import { EventBus } from '@/ui/EventBus';
import { Events } from '@/ui/events';
import { IssueLegacy } from '@/ui/pages/checklist/adaptors/IssueAdaptors';
import { createUserIdentifierFromActionPageKey } from '@/ui/injectionKeys';
import { CreateUserModelIdentifier } from '@/ui/components/user/CreateUserModal';

export const FillDetailsIssueModal = defineComponent({
  name: 'FillDetailsIssueModal',
  setup(_, context) {
    provide(createUserIdentifierFromActionPageKey, CreateUserModelIdentifier.actionCreator);

    const isModalOpen = computed(() => activeIssueEditable.value !== null);

    const onModalClose = () => {
      activeIssueEditable.value = null;
    };

    const onSubmit = () => {
      EventBus.$emit(Events.fillIssueDetailsInspectionPage);
    };

    const onSave = (issue: IssueLegacy) => {
      context.emit('save', issue);
    };

    EventBus.$on(Events.fillIssueDetailInspectionPageSave, onSave);

    onUnmounted(() => {
      EventBus.$off(Events.fillIssueDetailInspectionPageSave, onSave);
    });

    return function render() {
      return h(Modal, {
        props: { active: isModalOpen.value, width: '550px' },
        on: { close: onModalClose },
        scopedSlots: {
          actions: () => [
            h(Button, {
              props: { type: 'is-text', btnClass: 'mr-2 has-text-weight-semibold' },
              on: { click: onModalClose },
            }, t('common.cancel')),
            h(Button, {
              on: { click: onSubmit },
            }, t('common.save')),
          ],
        },
      }, [
        h('div', { class: 'fill-details-issue-modal' }, [
          pageSubtitle(t('common.issue')),
          isModalOpen.value ? [
            h(PrefilledFields),
            h(FillFields, { props: { value: activeIssueEditable.value } }),
          ] : null,
        ]),
      ]);
    };
  },
});
